import {FunctionComponent} from "react";
import { Switch } from "antd";
import {SwitchSize} from "antd/lib/switch";

import "./switchFilter.scss";

interface SwitchFilterProps {
    name: string;
    title: string;
    onChange: (params: any) => any;
    value: boolean;
    size?: SwitchSize;
}

export const SwitchFilter: FunctionComponent<SwitchFilterProps> = ({
     name,
     title,
     onChange,
     value,
     size
}) => {

    return <div className={"switch-filter-wrap"}>
        <label className="filter-label">{title}</label>
        <span className={"switch-filter-container"}><Switch onChange={( value:boolean ) => onChange( {
            target: {
                name,
                value
            }
        })} title={title} value={value} size={size || "small"}/></span>
    </div>
}